import { type CrudList, crudStoreFactory } from "@pasta/box-v2";
import { useLetterFileSavedFluxApi } from "../http/letter-file-saved-flux.api";
import { type LetterFileSavedFluxDto } from "../dto/letter-file-saved-flux.dto";

export const useLetterFileSavedFluxStore = crudStoreFactory(
  "letterFileSavedFlux",
  useLetterFileSavedFluxApi,
  (storeDef, api) => {
    return {
      ...storeDef,
      actions: {
        ...storeDef.actions,
        setFluxes(fluxes: CrudList<LetterFileSavedFluxDto>) {
          this.$patch(state => {
            state.list = fluxes;
            for (const el of fluxes.data) {
              state.map.set(el.id, el);
            }
          });
        },
        async getMines() {
          const result = await api.getMine();
          this.setFluxes(result);
        },
      },
    };
  }
);
